import script from "./DirectivosPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./DirectivosPanel.vue?vue&type=script&setup=true&lang=ts"

import "./DirectivosPanel.vue?vue&type=style&index=0&id=4396f254&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4396f254"]])

export default __exports__